module.exports = __webpack_public_path__ + "static/media/url_1_104.af8676a2.ico";